var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h5SignPageHeaderWrapper"},[_c('img',{staticClass:"h5Logo",attrs:{"src":require("@/assets/images/CwLogo.svg"),"alt":""}}),_c('LangSelect')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }